/**
 * Ryan O'Dowd
 * 2025-06-08
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  IconButton as PaperIconButton,
} from 'react-native-paper';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const IconButton = (props: IconButtonProps & React.ComponentProps<typeof PaperIconButton>) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <PaperIconButton
      size={styles.globalScale * 20}
      style={[...(Array.isArray(props.style) ? props.style : [props.style]), props.disabled && styles.disabled]}
      {...props}
    />
  );
};

class IconButtonProps {
  // @TODO: theme?: 'primary' | 'accent' | 'alert' | 'white' | 'primaryLight' | 'incorrect' | 'accentLight' | 'primaryDark'; // @TODO: this is also the name of a paper button prop, but that's not how it's being used // @TODO: this should be used instead of iconColor, containerColor, and rippleColor (disallow those three)
  // @TODO: disallow buttonColor, textColor (should always be theme)...at the very least, need to look at all usages of those two and update buttons accordingly
};

IconButton.displayName = 'IconButton';
export default IconButton;
